export const dateFormat = "DD/MM/YYYY";
export const filterOptions = [
  { name: "Bundle ID", value: "id" },
  { name: "Bundle Name", value: "name" },
  { name: "Type", value: "type" },
  { name: "Status", value: "status" },
  { name: "Start Date/End Date", value: "date" },
];

export const TYPES = [
  { name: "Kilo", value: "KB" },
  { name: "Time", value: "TB" },
];

export const STATUS_LIST = ["New", "Pending", "Active", "Inactive"];

export const STATUS_COLOR_MAP = {
  Active: {
    color: "#17C347",
    backgroundColor: "#D8FFE3",
  },
  Inactive: {
    color: "#FF0000",
    backgroundColor: "#FF00001A",
  },
  New: {
    color: "#DB6607",
    backgroundColor: "#DB660726",
  },
  Pending: {
    color: "#0085FF",
    backgroundColor: "#0085FF26",
  },
};

export const TYPES_MAP = {
  TB: "Time",
  KB: "Kilo",
};

export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];
